const form = {
  formId: "new-user-form",
  formField: {
    dear: {
      name: "dear",
      label: "Tên nơi nộp thuế:",
      type: "text",
      placeholder: "Nơi nộp thuế",
      errorMsg: "Vui lòng nhập tên nơi nộp thuế",
    },
    taxpayers: {
      name: "taxpayers",
      label: "Tên người nộp thuế:",
      type: "text",
      placeholder: "Người nộp thuế",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxCode: {
      name: "taxCode",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "Mã số thuế",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    notificationAddress: {
      name: "notificationAddress",
      label: "Địa chỉ nhận thông báo:",
      type: "text",
      placeholder: "Địa chỉ nhận thông báo",
      errorMsg: "Vui lòng nhập địa chỉ nhận thông báo",
    },
    phone: {
      name: "phone",
      label: "Điện thoại:",
      type: "text",
      placeholder: "Điện thoại",
      errorMsg: "Vui lòng nhập số điện thoại",
    },
    email: {
      name: "email",
      label: "E-mail:",
      type: "text",
      placeholder: "E-mail",
      errorMsg: "Vui lòng nhập e-mail",
    },
    textNumber: {
      name: "textNumber",
      label: "Số văn bản đề nghị:",
      type: "text",
      placeholder: "Số văn bản đề nghị",
      errorMsg: "Vui lòng nhập số văn bản đề nghị",
    },
    business: {
      name: "business",
      label: "Ngành nghề kinh doanh chính:",
      type: "text",
      placeholder: "Ngành nghề kinh doanh chính",
      errorMsg: "Vui lòng nhập ngành nghề kinh doanh chính",
    },
    title: {
      name: "title",
      label:
        "... đề nghị Cục Thuế Thành Phố ... miễn tiền chậm nộp phát sinh trong năm ... và năm ... còn nợ theo Nghị quyết  số 405/NQ-UBTVQH15 do phát sinh lỗ trong kỳ tính thuế năm 2020 với số tiền là:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số tiền",
    },
    sites: {
      name: "sites",
      label: "Địa danh",
      type: "text",
      errorMsg: "",
    },
    unitHeads: {
      name: "unitHeads",
      label: "Người ký:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người ký",
    },
    dateFounded: {
      name: "dateFounded",
      label: "Ngày ký:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
